// extracted by mini-css-extract-plugin
export default {"informationText":"styles_informationText__LojjP","text":"styles_text__6lWVR"};